import React, { useState, useEffect } from 'react';
import { Container, Title, Label } from "@bsf/force-ui";
import { __ } from '@wordpress/i18n';
import toast, { Toaster } from 'react-hot-toast';

const radioData = [
    {
        id: "1",
        title: __('Option 1 (Recommended)', 'uael'),
        description: __("This option will automatically replace your theme's header and footer files with custom templates from the plugin. It works with most themes and is selected by default.", "uael"),
        value: "1"
    },
    {
        id: "2",
        title: __('Option 2', 'uael'),
        description: __("This option will automatically replace your theme's header and footer files with custom templates from the plugin. It works with most themes and is selected by default.", "uael"),
        value: "2"
    }
];

const ThemeSupport = () => {
    // State to store the selected radio option
    const [selectedOption, setSelectedOption] = useState(uaelSettingsData.theme_option);

    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    const handleRadioChange = (event) => {
        const newValue = event.target.value;
        setSelectedOption(newValue); // Update the selected option in state

        // Only send the AJAX call if this is not the initial load
        if (!isInitialLoad) {
            saveOption(newValue);
        }
    };

    // Function to save the selected option.
    const saveOption = async (option) => {
        try {
            const response = await fetch(uaelSettingsData.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'save_hfe_compatibility_option', // WordPress action for your AJAX handler
                    hfe_compatibility_option: option,
                    nonce: uaelSettingsData.ajax_nonce // Nonce for security
                })
            });

            const result = await response.json();

            if (result.success) {
                toast.success("Settings saved successfully!");
            } else {
                toast.error("Failed to save settings");
            }
        } catch (error) {
            toast.error("Error saving settings");
        }
    };

    return (
        <>
            <Title
                description=""
                icon={null}
                iconPosition="right"
                size="sm"
                tag="h2"
                title="Theme Support"
            />
            <Container
                align="stretch"
                className="bg-background-primary p-6 rounded-lg"
                containerType="flex"
                direction="column"
                gap="sm"
                justify="start"
                style={{
                    marginTop: "24px",
                    maxWidth: "696px",
                }}
            >
                <Container.Item className="flex flex-col space-y-1">
                    <p className='text-base font-semibold m-0'>{__('Select Option to Add Theme Support', 'uael')}</p>
                    <p className='text-sm font-normal m-0'>
                        {__(
                            `To ensure compatibility between the ${uaelSettingsData.plugin_short_name}'s header/footer and your theme, please choose one of the following options to enable theme support:`,
                            'uael'
                        )}
                    </p>
                </Container.Item>
                <Container.Item
                    className="p-2 space-y-4"
                    alignSelf="auto"
                    order="none"
                >
                    {radioData.map((item) => (
                        <div key={item.id} className='flex items-start gap-1 justify-center cursor-pointer'>
                            <input
                                id={item.id}
                                value={item.value}
                                type='radio'
                                className='mt-1 cursor-pointer uae-radio-field'
                                name="hfe_compatibility_option" // Group radio buttons
                                onChange={handleRadioChange} // Track the change
                                checked={selectedOption === item.value} // Controlled input.
                            />
                            <div className='flex flex-col cursor-pointer'>
                                <Label
                                    size="sm"
                                    variant="neutral"
                                    className='text-sm font-semibold text-text-secondary cursor-pointer flex flex-col items-start justify-start'
                                    htmlFor={item.id}
                                >
                                    {item.title}:
                                    <p className='m-0 text-sm font-normal text-text-secondary cursor-pointer'>{item.description}</p>
                                </Label>
                            </div>
                        </div>
                    ))}
                </Container.Item>

                <div className='flex items-center p-4 border rounded-md text-start' style={{
                    paddingTop: '16px',
                    paddingBottom: '16px',
                    backgroundColor: "#F3F0FF",
                }}>
                    <p className='m-0'>
                        <strong>{__('Note:', 'uael')}</strong> {__('If neither option works, please contact your theme author to add support for this plugin.', 'uael')}
                    </p>
                </div>
            </Container>

            <Toaster
                position="top-right"
                reverseOrder={false}
                gutter={8}
                containerStyle={{
                    top: 20,
                    right: 20,
                    marginTop: '80px',
                }}
                toastOptions={{
                    duration: 5000,
                    style: {
                        background: 'white',
                    },
                    success: {
                        duration: 3000,
                        style: {
                            color: '',
                        },
                        iconTheme: {
                            primary: '#6005ff',
                            secondary: '#fff',
                        },
                    },
                }}
            />
        </>
    );
};

export default ThemeSupport;
